import React from "react";
import { get } from "lodash";

import { MOVIE_REVIEW_DETAILS } from "../../../constants";
import { FullStar } from "../../../arrow/components/Svgs/ReviewStars/fullStar";
import { HalfStar } from "../../../arrow/components/Svgs/ReviewStars/halfStar";
import { BorderStar } from "../../../arrow/components/Svgs/ReviewStars/borderStar";

import "./moview-review-card.m.css";

const MoviewReviewCard = ({ reviewInfo = {}, isSticky = false }) => {
  const getInfoCard = (title, value) => {
    return (
      <div styleName="card-wrapper">
        <div styleName="title">{title}</div>
        <div styleName="value">{value}</div>
      </div>
    );
  };

  return (
    <div styleName={`wrapper ${isSticky ? "sticky-wrapper" : "no-sticky-wrapper"}`}>
      <div>
        {isSticky && reviewInfo["review-title"] && <div styleName="movie-title">{reviewInfo["review-title"]}</div>}
        <div styleName="ratings-wrapper">
          <div styleName="rating-text">{MOVIE_REVIEW_DETAILS.ratings}</div>{" "}
          <div styleName="ratings-value-wrapper">
            <div styleName="stars">
              {[1, 2, 3, 4, 5].map((star) => {
                const rating = get(reviewInfo, ["review-rating", "value"], 0);
                const isFilled = star <= Math.floor(rating);
                const isHalf = rating % 1 !== 0 && star === Math.ceil(rating);

                if (isFilled) {
                  return <FullStar />;
                } else if (isHalf) {
                  return <HalfStar />;
                } else {
                  return <BorderStar />;
                }
              })}
            </div>
            <div>{get(reviewInfo, ["review-rating", "value"], "0.5")}/5</div>
          </div>
        </div>
      </div>
      <div styleName="row-wrapper">
        <div styleName={`first-row ${reviewInfo["director-name"] && reviewInfo.cast ? "with-border" : ""}`}>
          {reviewInfo["director-name"] && getInfoCard(MOVIE_REVIEW_DETAILS.director, reviewInfo["director-name"])}
          {reviewInfo.cast && getInfoCard(MOVIE_REVIEW_DETAILS.cast, reviewInfo.cast)}
        </div>
        <div styleName="second-row">
          {reviewInfo.producer && getInfoCard(MOVIE_REVIEW_DETAILS.producer, reviewInfo.producer)}
          {reviewInfo["music-director"] &&
            getInfoCard(MOVIE_REVIEW_DETAILS.musicDirector, reviewInfo["music-director"])}
        </div>
      </div>
    </div>
  );
};

export default MoviewReviewCard;
